<app-header></app-header>
<app-notifications></app-notifications>
<router-outlet></router-outlet>
<app-footer></app-footer>